import router from "@/router"
import RouteNames from "@/util/route_names"
import ProdukteLogic from "@/logic/produkte_logic"
import PreislisteZeitraumRequest from "@/entities/common/request/preisliste_zeitpunkt_request"
import { Terminart } from "@/entities/common/enums"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"
import PlisteProduktZeit from "@/entities/common/pliste_produkt_zeit"
import BstlArtikel from "@/entities/common/bstl_artikel"
import Bestellung from "@/entities/common/bestellung"
import ConverterUtil from "@/util/converter_util"
import BPArtikelHinzufuegenRequest from "@/entities/common/pending/bp_artikel_hinzufuegen_request"
import BPArtikelAnzahlRequest from "@/entities/common/pending/bp_artikel_anzahl_request"
import IdRequest from "@/entities/common/request/id_request"
import NachbestellungPending from "@/entities/common/nachbestellung_pending"

export default class NachbestellungLogic extends ProdukteLogic {
  bestellung: Bestellung = null
  bestellungCompleted: boolean = false
  insertCompleted: boolean = false

  private _warenkorb: BstlArtikel[] = []

  get warenkorb(): BstlArtikel[] {
    return this._warenkorb
  }

  get warenkorbGefuellt(): boolean {
    return this._warenkorb.length > 0
  }

  bestellungEinfuegen(): void {
    router.push({
      name: RouteNames.BESTELLUNG_PAGE.NACHBESTELLEN.BESTAETIGEN,
    })
  }

  loadPreislisten() {
    var request = new PreislisteZeitraumRequest()
    var terminart = this.bestellung.terminart

    if (terminart == Terminart.RESERVIERUNG) {
      request.zeitpunkt = this.bestellung.reservierung.zeitVon
    } else if (terminart == Terminart.SOFORTBESTELLUNG) {
      request.zeitpunkt = this.bestellung.bestellZp
    }

    request.filialeId = this.filiale.filialeId

    if (this.mainLogic.bestellung.nachbestellungPending)
      this._warenkorb =
        this.mainLogic.bestellung.nachbestellungPending.artikelliste

    this.loadError = false

    Poster.postUser<RemoteResult<PlisteProduktZeit>>(
      RestPaths.artikelPdukteNachZeitSingle,
      request
    )
      .then((response) => {
        if (response.data.success) {
          this.preisliste = response.data.payload
        } else {
          this.loadError = true
        }
      })
      .catch(() => {
        this.loadError = true
      })
  }

  init() {
    this.bestellung = this.mainLogic.bestellung
    if (this.bestellung != null) this.loadPreislisten()

    this.mainLogic.bestellungListeners.push(() => {
      this.bestellung = this.mainLogic.bestellung
      if (this.bestellung != null) this.loadPreislisten()
    })
  }

  increment(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = this.mainLogic.bestellung.nachbestellungPending.id
    request.artikelId = artikel.id
    request.anzahl = artikel.anzahl + 1

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingArtikelAendernNachbestellung,
      request
    ).then((response) => {
      if (response.data.success) {
        artikel.anzahl += 1
      }
    })
  }

  decrement(artikel: BstlArtikel) {
    if (artikel.anzahl > 1) {
      var request = new BPArtikelAnzahlRequest()
      request.id = this.mainLogic.bestellung.nachbestellungPending.id
      request.artikelId = artikel.id
      request.anzahl = artikel.anzahl - 1

      Poster.postUser<RemoteResult<any>>(
        RestPaths.bestellungpendingArtikelAendernNachbestellung,
        request
      ).then((response) => {
        if (response.data.success) {
          artikel.anzahl -= 1
        }
      })
    }
  }

  remove(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = this.mainLogic.bestellung.nachbestellungPending.id
    request.artikelId = artikel.id
    request.loeschen = true

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingArtikelAendernNachbestellung,
      request
    ).then((response) => {
      if (response.data.success) {
        this.warenkorb.splice(
          this.warenkorb.findIndex((x) => {
            return x.id === artikel.id
          }),
          1
        )
        if (this.warenkorb.length == 0) {
          router.go(-1)
        }
      }
    })
  }

  addArtikel(artikel: BstlArtikel) {
    var request = new BPArtikelHinzufuegenRequest()
    request.artikelData = ConverterUtil.convertBstlArtikel(artikel)
    request.id = this.mainLogic.bestellung.nachbestellungPending.id

    this.insertError = false

    Poster.postMember<RemoteResult<BstlArtikel>>(
      RestPaths.bestellungpendingArtikelHinzufuegenNachbestellung,
      request
    )
      .then((response) => {
        if (response.data.success) {
          this.warenkorb.push(response.data.payload)
          this.artikel = null
          this.artikelDialogVisible = false
          //router.go(-1)
        } else {
          this.insertError = true
        }
        this.insertWorking = false
      })
      .catch(() => {
        this.insertError = true
        this.insertWorking = false
      })
  }

  bestellungAufgeben() {
    this.insertWorking = true
    this.insertError = false
    this.insertCompleted = false

    var request = new IdRequest()
    request.id = this.mainLogic.bestellung.nachbestellungPending.id

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingNachbestellungAufgeben,
      request
    )
      .then((response) => {
        this.insertWorking = false
        if (response.data.success) {
          this.bestellungCompleted = true
          this.insertCompleted = true
          this.mainLogic.bestellung.nachbestellungPending =
            new NachbestellungPending()
        } else {
          this.insertError = true
        }
      })
      .catch(() => {
        this.insertWorking = false
        this.insertError = true
      })
  }

  backToOverview() {
    router.push({
      name: RouteNames.BESTELLUNG_PAGE.DETAILS,
      params: { id: this.bestellung.id },
    })
  }
}
